const en_purch_invoice = {
    "": "purchase invoice",
    add: "create purchase invoice",
    detail: "purchase invoice detail",
    edit: "edit purchase invoice",

    label: {
        file: "invoice proof",
        date_create: "invoice creation date",
        po_list_title: "PO list",
    },

    error: {
        create: "Failed to create purchase invoice.",
        edit: "Failed to update purchase invoice.",
    },

    success: {
        create: "Purchase invoice created successfully.",
        edit: "Purchase invoice updated successfully.",
    },
}

export default en_purch_invoice;